const SmsNew = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
    >
      <g mask='url(#mask0_315_8596)'>
        <path
          d='M4.33301 20C3.78301 20 3.31217 19.8042 2.92051 19.4125C2.52884 19.0208 2.33301 18.55 2.33301 18V6C2.33301 5.45 2.52884 4.97917 2.92051 4.5875C3.31217 4.19583 3.78301 4 4.33301 4H20.333C20.883 4 21.3538 4.19583 21.7455 4.5875C22.1372 4.97917 22.333 5.45 22.333 6V18C22.333 18.55 22.1372 19.0208 21.7455 19.4125C21.3538 19.8042 20.883 20 20.333 20H4.33301ZM12.333 13L4.33301 8V18H20.333V8L12.333 13ZM12.333 11L20.333 6H4.33301L12.333 11ZM4.33301 8V6V18V8Z'
          fill='#200000'
        />
      </g>
    </svg>
  );
};
export default SmsNew;
